import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { FetchBricksLocationType } from "../../../domain/models/user-hq-location-dashboard/fetch-bricks-location";
import { FetchBricksLocation } from "../../../domain/useages/user-hq-location-dashboard/fetch-bricks-location-data";
import { RemoteFetchBricksLocation } from "../../../data/usecases/user-hq-location-dashboard/remote-fetch-bricks-location";

export interface FetchBricksLocationInterface {
  FetchBricksLocation: FetchBricksLocationType;
  FetchBricksLocationState: FetchState;
  fetchBricksLocation: Function;

}

const initialStates = {
 FetchBricksLocation: {} as FetchBricksLocationType,
  FetchBricksLocationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchBricksLocationSlice: StateCreator<
 FetchBricksLocationInterface
> = (set) => ({
  ...initialStates,
  fetchBricksLocation: async (
    filter: FetchBricksLocation.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchBricksLocation = new RemoteFetchBricksLocation(
      `${BASE_URL}${Endpoints.FETCH_BRICKS_LOCATION}`,
      axiosHttpClient
    );

    set(() => ({ FetchBricksLocationState: FetchState.LOADING }));
    let result = await remoteFetchBricksLocation.fetch(filter);
    return result;
  },
});
